{
  "version": 1,
  "asset_id": "da2edf77-4169-4271-baa4-810e834a685f",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/da2edf77-4169-4271-baa4-810e834a685f/sence-cursos.webp",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/da2edf77-4169-4271-baa4-810e834a685f/sence-cursos.webp",
  "original_filename": "sence-cursos.webp",
  "size": 40182,
  "content_type": "image/webp",
  "created_at": "2026-07-23T03:26:00Z"
}
